module.exports = __webpack_public_path__ + "static/img/searchbackground.ac06602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/searchbackground.jpg
// module id = J6CG
// module chunks = 0